module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/WhyNeedSection/peaceful-mind-bc308619d193ea7197642fbd2964367e.png";